module.exports = __webpack_public_path__ + "static/courtesy_education04@2x-d1bc9d5560eebf56b84979f2a8277b99.png";